/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import Loading from 'components/Loading/Loading';

import Form from 'forms/_.extend';

import ActionDrawerHeader from 'views/ActionDrawer/components/ActionDrawerHeader/ActionDrawerHeader';

import ArchiveCostCenterForm from './ArchiveCostCenterForm/ArchiveCostCenterForm';
import ArchiveCostCenterSuccess from './ArchiveCostCenterSuccess/ArchiveCostCenterSuccess';
import ArchiveCostCenterError from './ArchiveCostCenterError/ArchiveCostCenterError';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {|
  formData: Object,
  actionDrawerStore: TypeActionDrawerStore,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class ArchiveCostCenter extends React.Component<*> {
  createForm = () => {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore }: TypeProps = this.props;
    const costCenter: Object = this.props.formData;
    const fields: Array<Object> = [
      {
        name: 'archiveCostCenterForm',
        label: t('general:actions.archive_cost_center'),
        title: 'Archive Cost Center',
        fields: [
          {
            name: 'reason',
            label: t('general:reasons.reason_for_archiving_cost_center'),
            rules: 'required|string',
            value: '',
            type: 'select',
            options: [
              {
                id: 1,
                label: t('general:reasons.options.cost_center_no_longer_in_use'),
              },
              {
                id: 2,
                label: t('general:reasons.options.cost_center_closed'),
              },
              {
                id: 'other',
                label: 'Other',
              },
            ],
          },
        ],
      },
    ];

    const hooks: Object = {
      onSuccess(data: Object) {
        const { reason }: Object = data.values().archiveCostCenterForm;

        actionDrawerStore.archiveCostCenter(costCenter.id, {
          activity_reason: reason,
        });
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        options: {
          validateOnInit: true,
          validateOnChange: true,
        },
        name: 'Archive Cost Center',
      }
    );
  };

  render(): React.Element<*> {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore }: TypeProps = this.props;
    const costCenter: Object = this.props.formData;

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={t('general:actions.archive_cost_center')} />
          <ArchiveCostCenterError costCenter={costCenter} response={actionDrawerStore.response} />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.success}`}>
          <ActionDrawerHeader title={t('general:actions.archive_cost_center')} />
          <ArchiveCostCenterSuccess response={actionDrawerStore.response} />
        </div>
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={t('general:actions.archive_cost_center')} />
        <ArchiveCostCenterForm costCenter={costCenter} form={this.createForm()} />
      </div>
    );
  }
}
